import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import StatusBar16ProMax from "../components/StatusBar16ProMax";
import GroupComponent from "../components/GroupComponent";
import HomeIndicator from "../components/HomeIndicator";

const Payment1 = () => {
  const navigate = useNavigate();

  const onMyMiChoClick = useCallback(() => {
    navigate("/41-history-5");
  }, [navigate]);

  const onDeviceClick = useCallback(() => {
    navigate("/41-setting-wifi");
  }, [navigate]);

  const onRectangleClick = useCallback(() => {
    navigate("/41-home");
  }, [navigate]);

  const onGroupContainerClick = useCallback(() => {
    navigate("/51-payment");
  }, [navigate]);

  const onGroupButtonClick = useCallback(() => {
    navigate("/42-setting-wifi-done1");
  }, [navigate]);

  return (
    <div className="w-full relative bg-light-primary-key-background overflow-hidden flex flex-col items-start justify-start gap-[59px] leading-[normal] tracking-[normal] text-left text-3xs text-dark-text font-text-regular-lowercase">
      <div className="w-[360px] h-40 relative rounded-xl bg-light-pink hidden max-w-full z-[0]" />
      <div className="w-[360px] h-40 relative rounded-t-xl rounded-b-none bg-light-orange hidden max-w-full z-[1]" />
      <div
        className="w-[175px] relative leading-[120%] hidden items-center cursor-pointer z-[2]"
        onClick={onMyMiChoClick}
      >
        <span className="w-full">
          <p className="m-0 text-lg">
            <span className="whitespace-pre-wrap">
              <span className="font-semibold">Máy mới cho Hùng</span>
            </span>
          </p>
          <p className="m-0">
            <span className="whitespace-pre-wrap">
              <span className="whitespace-pre-wrap">
                <span className="whitespace-pre-wrap">&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0 text-light-text">
            <span className="whitespace-pre-wrap">
              <span className="whitespace-pre-wrap">
                <span>Pin 18%</span>
              </span>
            </span>
          </p>
          <p className="m-0 text-dark-pink">
            <span className="whitespace-pre-wrap">
              <span className="whitespace-pre-wrap">
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0 text-sm">
            <span>
              <span className="whitespace-pre-wrap">
                <span>Hôm nay chưa nói</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span className="font-semibold whitespace-pre-wrap">&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span className="font-semibold whitespace-pre-wrap">
                {" "}
                Xem lịch sử nói chuyện
              </span>
            </span>
          </p>
        </span>
      </div>
      <img
        className="w-[116px] relative max-h-full object-cover hidden cursor-pointer z-[3]"
        alt=""
        src="/device-2-1@2x.png"
        onClick={onDeviceClick}
      />
      <img
        className="w-[116px] relative max-h-full object-cover hidden cursor-pointer z-[4]"
        alt=""
        src="/device-12-low-battery-1@2x.png"
        onClick={onDeviceClick}
      />
      <div
        className="relative leading-[120%] hidden cursor-pointer z-[5]"
        onClick={onMyMiChoClick}
      >
        <p className="m-0 text-lg">
          <span className="whitespace-pre-wrap">
            <span className="font-semibold">Máy của bé My</span>
          </span>
        </p>
        <p className="m-0">
          <span className="whitespace-pre-wrap">
            <span className="whitespace-pre-wrap">
              <span className="whitespace-pre-wrap">&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0 text-light-text">
          <span className="whitespace-pre-wrap">
            <span className="whitespace-pre-wrap">
              <span>Pin 18%</span>
            </span>
          </span>
        </p>
        <p className="m-0 text-dark-pink">
          <span className="whitespace-pre-wrap">
            <span className="whitespace-pre-wrap">
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0 text-sm">
          <span>
            <span className="whitespace-pre-wrap">
              <span>2000 câu từ lần cuối</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span className="font-semibold whitespace-pre-wrap">&nbsp;</span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span className="font-semibold whitespace-pre-wrap">
              {" "}
              Xem lịch sử nói chuyện
            </span>
          </span>
        </p>
      </div>
      <div className="w-[360px] h-10 relative hidden max-w-full z-[6] text-center text-sm text-light-primary-key-background">
        <div className="absolute top-[0px] left-[0px] rounded-t-none rounded-b-xl bg-dark-orange w-full h-full" />
        <div className="absolute top-[11px] left-[calc(50%_-_160px)] leading-[120%] flex items-center justify-center w-[321px]">
          Chưa thanh toán dịch vụ, free năm đầu tiên
        </div>
      </div>
      <img
        className="w-[9px] h-[9px] relative overflow-hidden shrink-0 hidden z-[7]"
        alt=""
        src="/calendar-month.svg"
      />
      <img
        className="w-[9px] h-[9px] relative overflow-hidden shrink-0 hidden z-[8]"
        alt=""
        src="/calendar-month.svg"
      />
      <div className="relative text-base font-medium text-light-text whitespace-pre-wrap text-center hidden z-[9]">
        + Thêm thiết bị mới
      </div>
      <div className="relative text-5xl font-semibold text-light-text hidden max-w-full z-[10]">
        Máy của bé My sắp hết pin!
      </div>
      <div
        className="w-full h-full absolute !m-[0] top-[0px] right-[0px] bottom-[0px] left-[0px] bg-dimgray cursor-pointer z-[3]"
        onClick={onRectangleClick}
      />
      {/* <StatusBar16ProMax
        statusBar16ProMaxBackgroundColor="unset"
        statusBar16ProMaxPosition="unset"
        statusBar16ProMaxTop="unset"
        statusBar16ProMaxLeft="unset"
      /> */}
      <main className="self-stretch flex flex-col items-start justify-start gap-10 max-w-full text-left text-base text-light-text font-text-regular-lowercase">
        <div className="flex flex-row items-start justify-start py-0 px-10">
          <div className="relative font-medium">Home</div>
        </div>
        <section className="self-stretch flex flex-col items-start justify-start max-w-full text-left text-21xl text-dark-text font-text-regular-lowercase">
          <div className="flex flex-row items-start justify-start py-0 px-10">
            <div className="flex flex-row items-start justify-start gap-[3px]">
              <h1 className="m-0 relative text-inherit font-semibold font-[inherit]">
                Chào Nam
              </h1>
              <div className="flex flex-col items-start justify-start pt-[19px] px-0 pb-0">
                <img
                  className="w-6 h-6 relative overflow-hidden shrink-0"
                  loading="lazy"
                  alt=""
                  src="/mode-edit-outline.svg"
                />
              </div>
            </div>
          </div>
          <div className="self-stretch rounded-t-21xl rounded-b-none bg-light-pink flex flex-col items-start justify-start pt-[61px] px-0 pb-0 box-border relative gap-[46px] max-w-full z-[4] text-right text-5xl">
            <div className="self-stretch h-[733px] relative rounded-t-21xl rounded-b-none bg-light-pink hidden z-[0]" />
            <div
              className="w-[153px] h-[161px] absolute !m-[0] top-[68px] right-[16px] rounded-xl bg-light-orange cursor-pointer z-[6]"
              onClick={onGroupContainerClick}
            >
              <div className="absolute top-[0px] left-[0px] rounded-xl bg-light-orange w-full h-full hidden" />
              <div className="absolute top-[9px] left-[14px] flex flex-col items-end justify-start gap-[5px]">
                <div className="relative font-semibold z-[1]">1 năm</div>
                <h3 className="m-0 relative text-inherit font-semibold font-[inherit] z-[1]">
                  6 tháng
                </h3>
              </div>
              <div className="absolute top-[9px] left-[113px] flex flex-col items-start justify-start pt-[3px] px-0 pb-0">
                <img
                  className="w-6 h-6 relative overflow-hidden shrink-0 object-contain z-[1]"
                  loading="lazy"
                  alt=""
                  src="/arrow-drop-down@2x.png"
                />
              </div>
            </div>
            <div className="self-stretch flex flex-row items-start justify-start py-0 px-10 box-border max-w-full text-left text-21xl">
              <div className="flex-1 flex flex-col items-start justify-start gap-[35px] max-w-full mq330:gap-[17px]">
                <div className="relative font-semibold z-[5]">200k</div>
                <div className="self-stretch flex flex-col items-start justify-start gap-[30px] max-w-full text-base">
                  <div className="self-stretch flex flex-col items-start justify-start pt-[26px] px-0 pb-0 box-border gap-5 max-w-full">
                    <div className="self-stretch rounded-xl bg-light-primary-key-background flex flex-col items-start justify-start pt-7 pb-[25px] pl-[29px] pr-[19px] box-border relative gap-[33px] max-w-full z-[5] mq330:gap-4">
                      <div className="w-[360px] h-40 relative rounded-xl bg-light-primary-key-background hidden max-w-full z-[0]" />
                      <div className="flex flex-col items-start justify-start gap-2.5">
                        <div className="relative z-[1]">Người Việt Nam</div>
                        <div className="relative text-light-text z-[1]">
                          5390 0147 2302 7353
                        </div>
                      </div>
                      <div className="self-stretch flex flex-row items-start justify-between gap-5">
                        <div className="flex flex-col items-start justify-start pt-1 px-0 pb-0">
                          <div className="relative z-[1]">Sacombank</div>
                        </div>
                        <img
                          className="h-6 w-6 relative overflow-hidden shrink-0 z-[1]"
                          loading="lazy"
                          alt=""
                          src="/mode-edit-outline.svg"
                        />
                      </div>
                      <h3 className="!m-[0] absolute top-[-26px] right-[22px] text-5xl font-semibold font-[inherit] text-right inline-block min-w-[93px] z-[1]">
                        3 tháng
                      </h3>
                      <h3 className="!m-[0] absolute top-[9px] right-[22px] text-5xl font-semibold font-[inherit] text-right inline-block min-w-[86px] z-[1]">
                        1 tháng
                      </h3>
                    </div>
                    <GroupComponent separator="0784218844" sacombank="MOMO" />
                  </div>
                  <div className="self-stretch flex flex-row items-start justify-start py-0 px-[50px] text-center text-light-text mq350small:pl-5 mq350small:pr-5 mq350small:box-border">
                    <div className="relative font-medium whitespace-pre-wrap z-[5]">
                      + Thêm tài khoàn giao dịch mới
                    </div>
                  </div>
                  <button
                    className="cursor-pointer [border:none] py-5 pl-[114px] pr-[113px] bg-[transparent] self-stretch rounded-81xl [background:linear-gradient(90deg,_#ff92d7,_#ffbc92)] flex flex-row items-start justify-center box-border max-w-full z-[5] mq360:pl-5 mq360:pr-5 mq360:box-border"
                    onClick={onGroupButtonClick}
                  >
                    <div className="h-[60px] w-[360px] relative rounded-81xl [background:linear-gradient(90deg,_#ff92d7,_#ffbc92)] hidden max-w-full" />
                    <div className="relative text-base font-medium font-text-regular-lowercase text-light-primary-key-background text-center z-[1]">
                      Thanh toán ngay
                    </div>
                  </button>
                </div>
              </div>
            </div>
            {/* <HomeIndicator
              homeIndicatorBackgroundColor="unset"
              homeIndicatorMargin="unset"
              homeIndicatorPosition="unset"
              homeIndicatorRight="unset"
              homeIndicatorBottom="unset"
              homeIndicatorLeft="unset"
              homeIndicatorTop="unset"
              homeIndicatorMarginTop="unset"
            /> */}
          </div>
        </section>
      </main>
    </div>
  );
};

export default Payment1;
